import React from 'react';
import {
  TableCellsIcon,
  ArrowPathIcon,
  CurrencyDollarIcon,
  ScaleIcon,
  DocumentTextIcon,
  ShieldExclamationIcon,
  ExclamationTriangleIcon,
} from '@heroicons/react/24/outline';

const cdagTables = [
  {
    label: 'Universe Table 1',
    short: 'CD',
    description: 'Standard and Expedited Coverage Determinations',
    universeType: 'cdag_table1_cd',
    gradient: 'from-orange-500 to-amber-500',
    icon: TableCellsIcon,
    color: 'blue'
  },
  {
    label: 'Universe Table 2',
    short: 'CDER',
    description: 'Standard and Expedited Coverage Determination Exception Requests',
    universeType: 'cdag_table2_cder',
    gradient: 'from-emerald-500 to-teal-500',
    icon: ArrowPathIcon,
    color: 'emerald'
  },
  {
    label: 'Universe Table 3',
    short: 'PYMT_D',
    description: 'Payment Coverage Determinations and Redeterminations',
    universeType: 'cdag_table3_pymt_d',
    gradient: 'from-purple-500 to-amber-500',
    icon: CurrencyDollarIcon,
    color: 'purple'
  },
  {
    label: 'Universe Table 4',
    short: 'RD',
    description: 'Standard and Expedited Redeterminations',
    universeType: 'cdag_table4_rd',
    gradient: 'from-orange-500 to-red-500',
    icon: ScaleIcon,
    color: 'orange'
  },
  {
    label: 'Universe Table 5',
    short: 'EFF_D',
    description: 'Part D Effectuations of Overturned Decisions by IRE, ALJ or MAC',
    universeType: 'cdag_table5_eff_d',
    gradient: 'from-pink-500 to-rose-500',
    icon: DocumentTextIcon,
    color: 'pink'
  },
  {
    label: 'Universe Table 6',
    short: 'GRV_D',
    description: 'Part D Standard and Expedited Grievances',
    universeType: 'cdag_table6_grv_d',
    gradient: 'from-violet-500 to-amber-500',
    icon: ShieldExclamationIcon,
    color: 'violet'
  },
  {
    label: 'Universe Table 7',
    short: 'AR',
    description: 'CARA At-Risk Determination',
    universeType: 'cdag_table7_ar',
    gradient: 'from-amber-500 to-orange-500',
    icon: ExclamationTriangleIcon,
    color: 'amber'
  },
];

export default function CDAGTableSelector({ onSelect }) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-100 relative overflow-hidden">
      <div className="relative z-10 max-w-6xl mx-auto px-6 py-16">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-3 px-6 py-3 bg-white/90 backdrop-blur-2xl border border-slate-200/60 rounded-2xl shadow-2xl mb-8">
            <div className="w-3 h-3 bg-gradient-to-r from-orange-500 via-amber-500 to-teal-500 rounded-full animate-pulse shadow-lg shadow-orange-500/50"></div>
            <span className="text-sm font-bold text-slate-700 tracking-wider uppercase">CDAG Protocol</span>
          </div>
          <h1 className="text-5xl font-black text-transparent bg-clip-text bg-gradient-to-r from-slate-900 via-orange-800 to-amber-700 mb-4 tracking-tight">
            Select Universe Table
          </h1>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto leading-relaxed font-light">
            Part D Coverage Determinations, Appeals, and Grievances
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
          {cdagTables.map((table) => {
            const Icon = table.icon;
            return (
              <button
                key={table.universeType}
                onClick={() => onSelect({ universeType: table.universeType, label: `${table.label}: ${table.short}`, protocol: 'CDAG' })}
                className="group relative bg-white/80 backdrop-blur-xl rounded-3xl border border-slate-200/60 p-8 text-left transition-all duration-500 hover:shadow-2xl hover:shadow-slate-300/50 hover:-translate-y-2 hover:border-slate-300/80"
              >
                <div className={`w-14 h-14 bg-gradient-to-br ${table.gradient} rounded-2xl flex items-center justify-center mb-5 shadow-xl group-hover:scale-110 transition-transform duration-500`}>
                  <Icon className="w-7 h-7 text-white" />
                </div>
                <div className="flex items-center gap-3 mb-3">
                  <span className="text-sm font-bold text-slate-400 tracking-wider">{table.label}</span>
                  <span className={`px-3 py-1 bg-gradient-to-r ${table.gradient} text-white text-xs font-bold rounded-full shadow-lg`}>
                    {table.short}
                  </span>
                </div>
                <p className="text-slate-600 text-sm leading-relaxed">{table.description}</p>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
